import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectModule } from "@angular/material/select";
import { RouterModule, Routes } from "@angular/router";
import { MaterialModule } from "../app.module";
import { ExponentEvaComponent } from "../exponent/eva/exponent-eva.component";
import { GraphComponent } from "./graph/graph.component";
import { HistogramComponent } from "./histogram/histogram.component";
import { ChartModule } from "angular-highcharts";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { HistogramTemplateComponent } from "./histogram/histogram-template/histogram-template.component";
import { MatTabsModule } from "@angular/material/tabs";

const routes: Routes = [
  { path: "epack", redirectTo: "exponenet/epack" },
  {
    path: "graph",
    component: GraphComponent,
  },
  {
    path: "raw-data",
    component: ExponentEvaComponent,
  },
  {
    path: "histogram",
    component: HistogramComponent,
  },
];

@NgModule({
  declarations: [
    GraphComponent,
    HistogramComponent,
    ExponentEvaComponent,
    HistogramTemplateComponent,
  ],
  imports: [
    CommonModule,
    // RouterModule.forChild(routes),
    FormsModule,
    // MaterialModule,
    MatIconModule,
    MatFormFieldModule,
    MatCardModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    ChartModule,
    MatDatepickerModule,
    MatTabsModule,
  ],
  exports: [GraphComponent, HistogramComponent, ExponentEvaComponent],
})
export class AnalyticsModule {}
